// extracted by mini-css-extract-plugin
export default {"address":"CompanyLocationMap_address__3khb4","underline":"CompanyLocationMap_underline__KMLHm","companyLocationMap":"CompanyLocationMap_companyLocationMap__EQx+V"};